import { Box, BoxProps } from 'theme-ui';
import React from 'react';

import { stylePropsGrid } from './style';

export interface GridProps extends BoxProps {
  align?: 'stretch' | 'flex-start' | 'flex-end' | 'center';
  autoFlow?: string;
  center?: boolean;
  childPadding?: string;
  className?: string;
  columnGap?: number | (number | null)[] | string | (string | null)[];
  columns: number | (number | null)[] | 'auto-fit' | 'auto-fill';
  minColumnWidth?: string;
  margins?: string;
  maxWidth?: string | number;
  rowGap?: number | (number | null)[] | string | (string | null)[];
}

const Grid = React.forwardRef<HTMLDivElement, GridProps>(
  (
    {
      align,
      autoFlow,
      center,
      childPadding,
      className,
      children,
      columnGap,
      columns,
      margins,
      maxWidth,
      minColumnWidth,
      rowGap,
      sx,
      ...props
    },
    ref
  ) => (
    <Box
      {...props}
      sx={{
        columnGap,
        rowGap,
        ...stylePropsGrid({
          align,
          autoFlow,
          center,
          columns,
          margins,
          maxWidth,
          minColumnWidth
        }),
        ...sx
      }}
      className={`Grid ${className}`.trim()}
      ref={ref}
    >
      {React.Children.map(children, (child) =>
        React.isValidElement(child) && childPadding
          ? React.cloneElement(child, {
              padding: childPadding
            })
          : child
      )}
    </Box>
  )
);

Grid.displayName = 'Grid';

Grid.defaultProps = {
  align: 'stretch',
  autoFlow: 'row',
  center: false,
  className: '',
  columnGap: 'm',
  columns: [4, null, 12],
  margins: '0 auto',
  maxWidth: 'desktop',
  rowGap: 's'
};

export default Grid;
